import { DatePicker } from 'antd';
import '@src/styles/components/customDatePicker.scss';
import styled from 'styled-components';
import datePickerIcon from '@src/assets/icons/icon-datepicker.svg';
import { CustomImage } from './index';
import { defaultDateFormat } from '@src/utils/keys';
import tr from '@src/utils/tr_locale.json';
import en from '@src/utils/en_locale.json';
import PropTypes from 'prop-types';

const { RangePicker } = DatePicker;

const DatePickerComponent = styled(DatePicker)(
  ({ height }) => `
  height: ${height || '58'}px;
  width: 100%;
  font-family: UbuntuRegular;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.86; 
  letter-spacing: normal;
  color: #3f4957;
  border-radius: 4px;
  
  ::placeholder {
    color: #6b7789;
  }
  
  :focus, .ant-picker-focused{
     border-color: #0d6efd !important;
      box-shadow: 0 0 8px 1px rgba(22, 32, 86, 0.08) !important;
  }
  :hover{
    border-color: #0d6efd;
  }
`,
);

const RangeDatePickerComponent = styled(RangePicker)(
  ({ height }) => `
  width: 100%;
  font-family: UbuntuRegular;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.86; 
  letter-spacing: normal;
  color: #3f4957;
  border-radius: 4px;
  
  ::placeholder {
    color: #6b7789;
  }
  
  :focus, .ant-picker-focused{
     border-color: #0d6efd !important;
      box-shadow: 0 0 8px 1px rgba(22, 32, 86, 0.08) !important;
  }
  :hover{
    border-color: #0d6efd;
  }
`,
);

const CustomDatePicker = ({ placeholder, format, isRangeDate = false, ...props }) => {
  const currentLocale = placeholder === 'Tarih Seç' ? tr : en;
  if (isRangeDate) {
    return (
      <RangeDatePickerComponent
        {...props}
        placeholder={[currentLocale.lang.rangePlaceholder[0], currentLocale.lang.rangePlaceholder[1]]}
        suffixIcon={<CustomImage src={datePickerIcon} />}
        format={format || defaultDateFormat}
        inputReadOnly={true}
        locale={currentLocale}
        className="custom-date-picker"
      />
    );
  }
  return (
    <DatePickerComponent
      {...props}
      placeholder={placeholder}
      suffixIcon={<CustomImage src={datePickerIcon} />}
      format={format || defaultDateFormat}
      inputReadOnly={true}
      locale={currentLocale}
      className="custom-date-picker"
    />
  );
};

CustomDatePicker.propTypes = {
  placeholder: PropTypes.string,
  format: PropTypes.any,
  isRangeDate: PropTypes.bool,
};

export default CustomDatePicker;
